import type { Namespace, NamespaceFile, NamespaceFileUrl } from './types.js';

export const formerStudents: Namespace = import.meta.glob<NamespaceFile>(
    '../locales/*/former-students.json' satisfies NamespaceFileUrl,
    { eager: true, import: 'default' },
);
